<template>
  <div class="menu" :class="{opened: isSmartphoneOpened}">
    <div class="smartphone-menu-trigger" @click="isSmartphoneOpened = !isSmartphoneOpened"></div>
    <img src="~@/assets/images/logo.svg" alt="Logo" class="img-fluid p-3"/>

    <ul class="sidebar-nav mt-3">
      <router-link tag="li" :to='{name: "Dashboard"}'>
        <a href="javascript:void(0)" class="icon-dashboard"><span>Dashboard</span></a>
      </router-link>

      <router-link tag="li" :to='{name: "Viewer"}'>
        <a href="javascript:void(0)" class="icon-viewer"><span>Mixed Reality Viewer</span></a>
      </router-link>
      <router-link tag="li" :to='{name: "Models"}' class="navbar-child">
        <a href="javascript:void(0)" class="navbar-child-link"><span>Models Storage</span></a>
      </router-link>

      <router-link v-if="isCompanionActive" tag="li" :to='{name: "Companion"}'>
        <a href="javascript:void(0)" class="icon-companion"><span>Companion</span></a>
      </router-link>
      <router-link v-if="isCompanionActive" tag="li" :to='{name: "CompanionModels"}' class="navbar-child">
        <a href="javascript:void(0)" class="navbar-child-link"><span>Models Storage</span></a>
      </router-link>
      <router-link v-if="isCompanionActive" tag="li" :to='{name: "Brochures"}' class="navbar-child">
        <a href="javascript:void(0)" class="navbar-child-link"><span>Immersive Brochures</span></a>
      </router-link>

      <router-link v-if="isWebARActive" tag="li" :to='{name: "WebAR"}'>
        <a href="javascript:void(0)" class="icon-web-ar"><span>Web AR</span></a>
      </router-link>
      <router-link v-if="isWebARActive" tag="li" :to='{name: "WebARModels"}' class="navbar-child">
        <a href="javascript:void(0)" class="navbar-child-link"><span>Models Storage</span></a>
      </router-link>
      <router-link v-if="isWebARActive" tag="li" :to='{name: "WebAREmbeds"}' class="navbar-child">
        <a href="javascript:void(0)" class="navbar-child-link"><span>Immersive Embeds</span></a>
      </router-link>

      <router-link tag="li" :to='{name: "Support"}'>
        <a href="javascript:void(0)" class="icon-support"><span>Support</span></a>
      </router-link>

      <router-link tag="li" :to='{name: "Subscription"}'>
        <a href="javascript:void(0)" class="icon-account"><span>Account</span></a>
      </router-link>

      <li class="last-item">
        <a href="javascript:void(0)" @click="logout()" class="icon-logout"><span>Logout</span></a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Sidebar",
  data() {
    return {
      isSmartphoneOpened: false
    }
  },
  computed: {
    ...mapGetters([ "isCompanionActive", "isWebARActive", "isBusiness", "isEnterprise" ])
  },
  methods: {
    ...mapActions([ "logout" ])
  }
}
</script>
